import styled from 'styled-components';

export const StyledPolicy = styled.div`
  ol {
    margin: 0;
    padding: 0;
  }
  table td,
  table th {
    padding: 0;
  }
  .c11 {
    background-color: #ffffff;
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 11pt;
    font-family: 'Times New Roman';
    font-style: normal;
  }
  .c16 {
    background-color: #ffffff;
    margin-left: 35.5pt;
    padding-top: 14pt;
    padding-bottom: 14pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: justify;
  }
  .c14 {
    margin-left: 53.5pt;
    padding-top: 12pt;
    padding-left: 17.5pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: justify;
  }
  .c3 {
    margin-left: 18pt;
    padding-top: 12pt;
    padding-left: 17.5pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: justify;
  }
  .c12 {
    margin-left: 18.2pt;
    padding-top: 12pt;
    padding-left: 17.5pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: justify;
  }
  .c9 {
    background-color: #ffffff;
    padding-top: 12pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: center;
  }
  .c8 {
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 11pt;
    font-family: 'Arial';
    font-style: normal;
  }
  .c4 {
    margin-left: 35.5pt;
    padding-top: 12pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: justify;
  }
  .c15 {
    margin-left: 35.5pt;
    padding-top: 12pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c5 {
    margin-left: 35.7pt;
    padding-top: 12pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: justify;
  }
  .c17 {
    margin-left: 1.4pt;
    padding-top: 12pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: center;
  }
  .c2 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 11pt;
    font-family: 'Calibri';
    font-style: normal;
  }
  .c1 {
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 11pt;
    font-family: 'Calibri';
    font-style: normal;
  }
  .c29 {
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c21 {
    padding-top: 12pt;
    padding-bottom: 0pt;
    line-height: 1;
    orphans: 2;
    widows: 2;
    text-align: justify;
  }
  .c27 {
    color: #000000;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 11pt;
    font-style: normal;
  }
  .c20 {
    color: #000000;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 10pt;
    font-style: normal;
  }
  .c24 {
    background-color: #ffffff;
    max-width: 451.4pt;
    padding: 72pt 72pt 72pt 72pt;
  }
  .c7 {
    font-weight: 400;
    font-family: 'Times New Roman';
  }
  .c30 {
    color: inherit;
    text-decoration: inherit;
  }
  .c23 {
    width: 33%;
    height: 1px;
  }
  .c10 {
    font-weight: 400;
    font-family: 'Calibri';
  }
  .c0 {
    padding: 0;
    margin: 0;
  }
  .c6 {
    font-weight: 700;
    font-family: 'Calibri';
  }
  .c22 {
    vertical-align: super;
  }
  .c25 {
    font-size: 10pt;
  }
  .c26 {
    background-color: #ffff00;
  }
  .c28 {
    page-break-after: avoid;
  }
  .c13 {
    height: 11pt;
  }
  .c19 {
    font-style: italic;
  }
  .c18 {
    color: #2f5496;
  }
  .title {
    padding-top: 0pt;
    color: #000000;
    font-size: 26pt;
    padding-bottom: 3pt;
    font-family: 'Arial';
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .subtitle {
    padding-top: 0pt;
    color: #666666;
    font-size: 15pt;
    padding-bottom: 16pt;
    font-family: 'Arial';
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  li {
    color: #000000;
    font-size: 11pt;
    font-family: 'Arial';
  }
  p {
    margin: 0;
    color: #000000;
    font-size: 11pt;
    font-family: 'Arial';
  }
  h1 {
    padding-top: 20pt;
    color: #000000;
    font-size: 20pt;
    padding-bottom: 6pt;
    font-family: 'Arial';
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h2 {
    padding-top: 18pt;
    color: #000000;
    font-size: 16pt;
    padding-bottom: 6pt;
    font-family: 'Arial';
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h3 {
    padding-top: 16pt;
    color: #434343;
    font-size: 14pt;
    padding-bottom: 4pt;
    font-family: 'Arial';
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h4 {
    padding-top: 14pt;
    color: #666666;
    font-size: 12pt;
    padding-bottom: 4pt;
    font-family: 'Arial';
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h5 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: 'Arial';
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h6 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: 'Arial';
    line-height: 1.15;
    page-break-after: avoid;
    font-style: italic;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
`;
